module.exports = __webpack_public_path__ + "img/ic_share_tw.0a73c86.svg";